import { IComponentOptions } from "angular";
import { PartTransactionItemController } from "../partTransactionItemController";

export const vsComponentName = "partTransactionDetailPartLocation";

export const partTransactionDetailPartLocationComponent: IComponentOptions = {
  bindings: {
    item: "<",
  },
  controller: PartTransactionItemController,
  controllerAs: "ctrl",
  template: require("!html-loader!./index.html").default,
};
